var React = require('react');

function LogoPlainGradient (props) {
    return React.createElement("svg",props,[React.createElement("linearGradient",{"id":"a","x1":"0%","x2":"100.0005%","y1":"50%","y2":"50%","key":0},[React.createElement("stop",{"offset":"0","stopColor":"#8d49f7","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#6b53ff","key":1})]),React.createElement("path",{"d":"m62.7107356 6.14213562 28.2842713 28.28427128c7.8104858 7.8104858 7.8104858 20.4737854 0 28.2842712l-28.2842713 28.2842713c-7.8104858 7.8104858-20.4737854 7.8104858-28.2842712 0l-28.28427127-28.2842713c-7.81048584-7.8104858-7.81048584-20.4737854 0-28.2842712l28.28427127-28.28427128c7.8104858-7.81048583 20.4737854-7.81048583 28.2842712 0z","fill":"url(#a)","key":1})]);
}

LogoPlainGradient.defaultProps = {"height":"97","viewBox":"0 0 97 97","width":"97"};

module.exports = LogoPlainGradient;

LogoPlainGradient.default = LogoPlainGradient;
